import ot from "../util/browser-detector.js";
import ue from "../models/braze-event.js";
import _t from "../models/identifier.js";
import {
  isArray as p,
  keys as or,
  validateValueIsFromEnum as F,
  values as Lt
} from "../util/code-utils.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { User } from "../User/index.js";
export const STORAGE_KEYS = {
  eu: {
    su: "ab.storage.userId",
    Jo: "ab.storage.deviceId",
    xh: "ab.storage.sessionId"
  },
  q: {
    Sa: "ab.test",
    Ta: "ab.storage.events",
    Ia: "ab.storage.attributes",
    Ka: "ab.storage.attributes.anonymous_user",
    Xo: "ab.storage.device",
    oa: "ab.storage.sdk_metadata",
    ua: "ab.storage.session_id_for_cached_metadata",
    vn: "ab.storage.pushToken",
    Di: "ab.storage.newsFeed",
    xi: "ab.storage.lastNewsFeedRefresh",
    P: "ab.storage.cardImpressions",
    hl: "ab.storage.serverConfig",
    Ya: "ab.storage.triggers",
    Da: "ab.storage.triggers.ts",
    Gh: "ab.storage.messagingSessionStart",
    Yt: "ab.storage.cc",
    vs: "ab.storage.ccLastFullSync",
    ys: "ab.storage.ccLastCardUpdated",
    $: "ab.storage.ccClicks",
    O: "ab.storage.ccImpressions",
    K: "ab.storage.ccDismissals",
    Ga: "ab.storage.lastDisplayedTriggerTimesById",
    Na: "ab.storage.lastDisplayedTriggerTime",
    va: "ab.storage.triggerFireInstancesById",
    Ln: "ab.storage.signature",
    As: "ab.storage.brazeSyncRetryCount",
    _s: "ab.storage.sdkVersion",
    di: "ab.storage.ff",
    vi: "ab.storage.ffLastRefreshAt"
  },
  ae: "ab.optOut"
};
export default class G {
  constructor(t, e) {
    (this.Ca = t), (this.Ma = e);
  }
  uu(t, e) {
    let s = e;
    null != e && e instanceof _t && (s = e.ss()), this.Ca.store(t, s);
  }
  ya(t) {
    const e = this.tu(t);
    null != e && ((e.Wh = new Date().valueOf()), this.uu(t, e));
  }
  tu(t) {
    return _t.Pn(this.Ca.lr(t));
  }
  Jh(t) {
    this.Ca.remove(t);
  }
  bo(t) {
    if (null == t || 0 === t.length) return !1;
    p(t) || (t = [t]);
    let e = this.Ma.lr(STORAGE_KEYS.q.Ta);
    (null != e && p(e)) || (e = []);
    for (let s = 0; s < t.length; s++) e.push(t[s].ss());
    return this.Ma.store(STORAGE_KEYS.q.Ta, e);
  }
  qh(t) {
    return null != t && this.bo([t]);
  }
  Ua() {
    let t = this.Ma.lr(STORAGE_KEYS.q.Ta);
    this.Ma.remove(STORAGE_KEYS.q.Ta), null == t && (t = []);
    const e = [];
    let s = !1,
      o = null;
    if (p(t))
      for (let s = 0; s < t.length; s++)
        ue.Fa(t[s]) ? e.push(ue.Pn(t[s])) : (o = s);
    else s = !0;
    if (s || null != o) {
      let n = "Stored events could not be deserialized as Events";
      s &&
        (n += ", was " + Object.prototype.toString.call(t) + " not an array"),
        null != o &&
          (n += ", value at index " + o + " does not look like an event"),
        (n +=
          ", serialized values were of type " +
          typeof t +
          ": " +
          JSON.stringify(t)),
        e.push(new ue(null, r.A.qs, new Date().valueOf(), null, { e: n }));
    }
    return e;
  }
  B(t, e) {
    return (
      !!F(
        STORAGE_KEYS.q,
        t,
        "StorageManager cannot store object.",
        "STORAGE_KEYS.OBJECTS"
      ) && this.Ma.store(t, e)
    );
  }
  I(t) {
    return (
      !!F(
        STORAGE_KEYS.q,
        t,
        "StorageManager cannot retrieve object.",
        "STORAGE_KEYS.OBJECTS"
      ) && this.Ma.lr(t)
    );
  }
  Xs(t) {
    return (
      !!F(
        STORAGE_KEYS.q,
        t,
        "StorageManager cannot remove object.",
        "STORAGE_KEYS.OBJECTS"
      ) && (this.Ma.remove(t), !0)
    );
  }
  Wo(t) {
    const e = or(STORAGE_KEYS.eu),
      s = new G.ne(t);
    for (const t of e) s.remove(STORAGE_KEYS.eu[t]);
  }
  clearData() {
    const t = or(STORAGE_KEYS.eu),
      e = or(STORAGE_KEYS.q);
    for (let e = 0; e < t.length; e++) {
      const s = t[e];
      this.Ca.remove(STORAGE_KEYS.eu[s]);
    }
    for (let t = 0; t < e.length; t++) {
      const s = e[t];
      this.Ma.remove(STORAGE_KEYS.q[s]);
    }
  }
  La(t) {
    return t || STORAGE_KEYS.q.Ka;
  }
  qa(t) {
    let e = this.Ma.lr(STORAGE_KEYS.q.Ia);
    null == e && (e = {});
    const s = this.La(t[User.Dn]);
    for (let r in t)
      r === User.Dn ||
        (null != e[s] && null != e[s][r]) ||
        this.mu(t[User.Dn], r, t[r]);
  }
  mu(t, e, s) {
    let r = this.Ma.lr(STORAGE_KEYS.q.Ia);
    null == r && (r = {});
    const o = this.La(t);
    let n = r[o];
    if (
      (null == n && ((n = {}), null != t && (n[User.Dn] = t)), e === User.lu)
    ) {
      null == n[e] && (n[e] = {});
      for (let t in s) n[e][t] = s[t];
    } else n[e] = s;
    return (r[o] = n), this.Ma.store(STORAGE_KEYS.q.Ia, r);
  }
  Ba() {
    const t = this.Ma.lr(STORAGE_KEYS.q.Ia);
    this.Ma.remove(STORAGE_KEYS.q.Ia);
    const e = [];
    for (let s in t) null != t[s] && e.push(t[s]);
    return e;
  }
  ou(t) {
    const e = this.Ma.lr(STORAGE_KEYS.q.Ia);
    if (null != e) {
      const s = this.La(null),
        r = e[s];
      null != r &&
        ((e[s] = void 0),
        this.Ma.store(STORAGE_KEYS.q.Ia, e),
        (r[User.Dn] = t),
        this.qa(r));
    }
    const s = this.tu(STORAGE_KEYS.eu.xh);
    let r = null;
    null != s && (r = s.iu);
    const o = this.Ua();
    if (null != o)
      for (let e = 0; e < o.length; e++) {
        const s = o[e];
        null == s.userId && s.sessionId == r && (s.userId = t), this.qh(s);
      }
  }
  Pa() {
    return this.Ma.ka;
  }
}
G._a = class {
  constructor(t) {
    (this._r = t), (this.ka = ot.xa() ? 3 : 10);
  }
  Ja(t) {
    return t + "." + this._r;
  }
  store(t, e) {
    const s = { v: e };
    try {
      return localStorage.setItem(this.Ja(t), JSON.stringify(s)), !0;
    } catch (t) {
      return r.D.info("Storage failure: " + t.message), !1;
    }
  }
  lr(t) {
    try {
      const e = JSON.parse(localStorage.getItem(this.Ja(t)));
      return null == e ? null : e.v;
    } catch (t) {
      return r.D.info("Storage retrieval failure: " + t.message), null;
    }
  }
  remove(t) {
    try {
      localStorage.removeItem(this.Ja(t));
    } catch (t) {
      return r.D.info("Storage removal failure: " + t.message), !1;
    }
  }
};
G.ne = class {
  constructor(t, e) {
    (this._r = t), (this.Va = this.za()), (this.Qa = 576e3), (this.Ha = !!e);
  }
  Ja(t) {
    return null != this._r ? t + "." + this._r : t;
  }
  za() {
    let t = 0,
      e = document.location.hostname;
    const s = e.split("."),
      r = "ab._gd";
    for (; t < s.length - 1 && -1 === document.cookie.indexOf(r + "=" + r); )
      t++,
        (e = "." + s.slice(-1 - t).join(".")),
        (document.cookie = r + "=" + r + ";domain=" + e + ";");
    return (
      (document.cookie =
        r + "=;expires=" + new Date(0).toGMTString() + ";domain=" + e + ";"),
      e
    );
  }
  ie() {
    const t = new Date();
    return t.setTime(t.getTime() + 60 * this.Qa * 1e3), t.getFullYear();
  }
  Wa() {
    const t = Lt(STORAGE_KEYS.eu),
      e = document.cookie.split(";");
    for (let s = 0; s < e.length; s++) {
      let r = e[s];
      for (; " " === r.charAt(0); ) r = r.substring(1);
      let o = !1;
      for (let e = 0; e < t.length; e++)
        if (0 === r.indexOf(t[e])) {
          o = !0;
          break;
        }
      if (o) {
        const t = r.split("=")[0];
        -1 === t.indexOf("." + this._r) && this.Xa(t);
      }
    }
  }
  store(t, e) {
    this.Wa();
    const s = new Date();
    s.setTime(s.getTime() + 60 * this.Qa * 1e3);
    const o = "expires=" + s.toUTCString(),
      n = "domain=" + this.Va;
    let i;
    i = this.Ha ? e : encodeURIComponent(JSON.stringify(e));
    const a = this.Ja(t) + "=" + i + ";" + o + ";" + n + ";path=/";
    return a.length >= 4093
      ? (r.D.info(
          "Storage failure: string is " +
            a.length +
            " chars which is too large to store as a cookie."
        ),
        !1)
      : ((document.cookie = a), !0);
  }
  lr(t) {
    const e = [],
      s = this.Ja(t) + "=",
      o = document.cookie.split(";");
    for (let n = 0; n < o.length; n++) {
      let i = o[n];
      for (; " " === i.charAt(0); ) i = i.substring(1);
      if (0 === i.indexOf(s))
        try {
          let t;
          (t = this.Ha
            ? i.substring(s.length, i.length)
            : JSON.parse(decodeURIComponent(i.substring(s.length, i.length)))),
            e.push(t);
        } catch (e) {
          return (
            r.D.info("Storage retrieval failure: " + e.message),
            this.remove(t),
            null
          );
        }
    }
    return e.length > 0 ? e[e.length - 1] : null;
  }
  remove(t) {
    this.Xa(this.Ja(t));
  }
  Xa(t) {
    const e = t + "=;expires=" + new Date(0).toGMTString();
    (document.cookie = e), (document.cookie = e + ";path=/");
    const s = e + ";domain=" + this.Va;
    (document.cookie = s), (document.cookie = s + ";path=/");
  }
};
G.Oa = class {
  constructor() {
    (this.Za = {}), (this.$a = 5242880), (this.ka = 3);
  }
  store(t, e) {
    const s = { value: e },
      o = this.El(e);
    return o > this.$a
      ? (r.D.info(
          "Storage failure: object is ≈" +
            o +
            " bytes which is greater than the max of " +
            this.$a
        ),
        !1)
      : ((this.Za[t] = s), !0);
  }
  El(t) {
    const e = [],
      s = [t];
    let r = 0;
    for (; s.length; ) {
      const t = s.pop();
      if ("boolean" == typeof t) r += 4;
      else if ("string" == typeof t) r += 2 * t.length;
      else if ("number" == typeof t) r += 8;
      else if ("object" == typeof t && -1 === e.indexOf(t)) {
        e.push(t);
        for (let e in t) s.push(t[e]);
      }
    }
    return r;
  }
  lr(t) {
    const e = this.Za[t];
    return null == e ? null : e.value;
  }
  remove(t) {
    this.Za[t] = null;
  }
};
G.wa = class {
  constructor(t, e, s) {
    (this._r = t),
      (this.Sl = []),
      e && this.Sl.push(new G.ne(t)),
      s && this.Sl.push(new G._a(t)),
      this.Sl.push(new G.Oa(t));
  }
  store(t, e) {
    let s = !0;
    for (let r = 0; r < this.Sl.length; r++) s = this.Sl[r].store(t, e) && s;
    return s;
  }
  lr(t) {
    for (let e = 0; e < this.Sl.length; e++) {
      const s = this.Sl[e].lr(t);
      if (null != s) return s;
    }
    return null;
  }
  remove(t) {
    new G.ne(this._r).remove(t);
    for (let e = 0; e < this.Sl.length; e++) this.Sl[e].remove(t);
  }
};
